import css from "styled-jsx/css";

export const componentStyles = css`
  .tab {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    position: relative;
    cursor: pointer;
    transition: all 0.33s cubic-bezier(0.38, 0.8, 0.32, 1.07);
    padding: 0 20px;
    align-items: center;
    min-width: 100px;

    .icon-wrapper {
      display: flex;
      justify-content: center;
      padding-top: 8px;
      opacity: 0.5;
      position: relative;
      .icon-absolute-container {
        position: absolute;
        top: 0;
        opacity: 0;
        &.visible {
          opacity: 1;
        }
      }
    }

    .name {
      font-weight: 300;
      opacity: 0.5;
      transition: all 0.33s cubic-bezier(0.38, 0.8, 0.32, 1.07);
    }

    .marker {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 4px;
      width: 100%;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      transition: all 0.33s cubic-bezier(0.38, 0.8, 0.32, 1.07);
    }
    &.selected {
      cursor: pointer;
      .icon-wrapper {
        opacity: 1;
      }
      .name {
        opacity: 1;
      }
    }
  }
`;
